// extracted by mini-css-extract-plugin
export default {"form":"EditOrganisation_form__0F1Hc","formGroup":"EditOrganisation_formGroup__FvCx2"};